import { MaintenanceDashboard } from '@/features/garage/components/MaintenanceDashboard';

export function DashboardPage(): JSX.Element {
  return <MaintenanceDashboard />;
}
